
import React from 'react';
import {useTranslation} from "react-i18next";
import {MouseParallax} from "react-just-parallax";
import {MotionAnimate} from "react-motion-animate";
import '../../styles/book.css';
import {Link} from "react-router-dom";

function BooksSection(props) {

    const { t, i18n } = useTranslation()

    return (<>

        <div className="row justify-content-center align-items-center p-2 rounded-5">
            <div className="col-md-6 col-12 p-md-5 p-3">

                <p className={'lead text-secondary mt-5 mb-5 pb-2'}>
                    2024
                </p>

                <a href="https://books.lukyanchuk.com/book/one-percent-changes-do-it-now/" target={'_blank'} className={'text-dark text-decoration-none'}>
                    <h2 className={'display-2'}>
                        1% Змін.
                    </h2>
                    <span className="text-secondary">
                        Час зроби це зараз!
                    </span>
                </a>

                <div className="row mt-5">
                    <div className="col-md-8 col-12">

                            <div style={{opacity: "1", transform: "none"}}>
                                <div className="d-flex flex-wrap">

                                    <Link
                                        to="https://books.lukyanchuk.com/book"
                                        className="btn btn-dark shadow-lg p-3 d-flex align-items-center justify-content-center col-md-12 col-12 rounded-5">
                                           <span className="display- lead m-0">
                                               {t('read')}
                                           </span>
                                    </Link>

                                </div>
                            </div>

                    </div>
                </div>
            </div>


            <div className="col-md-6 text-center d-none d-md-block">
                {/*<MouseParallax>*/}

                <MotionAnimate
                    animation='fadeInUp'
                    reset={true}
                    distance={100}
                    delay={1}
                    speed={1}>
                    <a
                        className="book-container col-md-12 col-12"
                        href="https://books.lukyanchuk.com/book/one-percent-changes-do-it-now/"
                        rel="noreferrer noopener"
                    >
                        <div className="book">
                            <img
                                className={'img-fluid'}
                                alt="book"
                                src={'/assets/img/products/book_cover.png'}
                            />
                        </div>
                    </a>

                </MotionAnimate>
                {/*</MouseParallax>*/}

            </div>

        </div>
    </>);
}

export default BooksSection;
